import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useInsightStatusBadge } from '@/utils/composables/useInsightStatusBadge';
import { useUnviewedNotifications } from '@/utils/composables/useUnviewedNotifications';
import { useUserDocumentNotification } from '@/utils/composables/useUserDocumentNotification';
import { useGroups } from '@/utils/swr';

export const useLeftSectionMenu = () => {
  const route = useRoute();

  const { data: groups } = useGroups();
  const { isAdminUser, hasUserDocumentNotification: hasAdminNotification } =
    useUserDocumentNotification();

  const allUserGroupId = computed(
    () =>
      groups.value?.groups.find(group => group.group_type === 'all_user_group')
        ?.id,
  );

  const { hasUnviewedNotification, refetch: refetchUnviewedNotifications } =
    useUnviewedNotifications();

  /** ルーティングが切り替わる都度通知の再フェッチ */
  watch(
    () => route.path,
    () => refetchUnviewedNotifications(),
  );

  const { hasUnviewedInsight } = useInsightStatusBadge({ observe: true });

  return {
    isAdminUser,
    allUserGroupId,
    hasAdminNotification,
    hasUnviewedNotification,
    hasUnviewedInsight,
  };
};
